import { render } from "./EmergencyComments.vue?vue&type=template&id=283b8d73"
import script from "./EmergencyComments.ts?vue&type=script&lang=js&external"
export * from "./EmergencyComments.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__